export enum ViewEnum {
    ViewFlat = 'viewFlat',
    ViewDetails = 'viewDetails'
}